import Mutations from '../../odata/mutations';

export default { ...new Mutations('packingListPallet'), ...new Mutations('packingListPallets') };
